import get from 'lodash.get';

const getCriticalError = (rootState) => get(rootState, 'criticalError', null);

export default getCriticalError;
